module.exports = __webpack_public_path__ + "img/pov-crap.60b7bd60.svg";